import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {CreateLocationSchemaParams, UpdateLocationSchemaParams} from './SampleSchemaActions';
import {LocationSchema} from './storables/StorableSchemaConstants';

interface CreateLocationSchemaWithRegistryId extends CreateLocationSchemaParams {
  registryId: string;
}

export function fetchAll(): JQueryPromise<{data: Array<LocationSchema>}> {
  return net.getJSON('/1/api/location-schemas');
}

export function create(data: CreateLocationSchemaWithRegistryId): JQueryPromise<LocationSchema> {
  return net.postJSON({url: '/1/api/location-schemas', data});
}

export function update(
  locationSchemaId: string,
  data: UpdateLocationSchemaParams
): JQueryPromise<LocationSchema> {
  return TaskRunner.patchJSON({url: `/1/api/location-schemas/${locationSchemaId}`, data});
}

export function deleteLocationSchema(locationSchemaId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/location-schemas/${locationSchemaId}`});
}
